exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app,body,html{width:100%;height:100%;padding:0;margin:0;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":true,"localIdentName":"[name]__[local]"}!./client/viewer.css
// module id = 29
// module chunks = 0